import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { Ban, XCircle } from 'lucide-react';

interface Stage07DialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedOpportunity: any;
  onLost: () => void;
  onCancelled: () => void;
  onCancel: () => void;
}

export function Stage07Dialog({
  isOpen,
  onOpenChange,
  selectedOpportunity,
  onLost,
  onCancelled,
  onCancel
}: Stage07DialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="glass-dialog w-200">
        <DialogHeader>
          <DialogTitle>Opportunity Status</DialogTitle>
          <DialogDescription>
            Is this opportunity Lost or Cancelled?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Opportunity Details */}
          <div className="glass-card p-4 space-y-2">
            <div className="flex justify-between items-start">
              <div>
                <p className="font-medium">{selectedOpportunity?.end_user.name}</p>
                <p className="text-sm text-muted-foreground">{selectedOpportunity?.opportunity_id}</p>
              </div>
              <Badge variant="outline" className="glass-badge">
                {selectedOpportunity?.opportunity_value}
              </Badge>
            </div>
          </div>

          <div className="space-y-3 pr-4">
            <Button
              onClick={onLost}
              variant="outline"
              className="w-full justify-start h-auto py-4 border-worldsview-orange hover:bg-worldsview-orange/10"
            >
              <div className="flex items-start gap-3">
                <XCircle className="w-5 h-5 text-worldsview-orange mt-0.5" />
                <div className="text-left min-w-0">
                  <p className="font-medium text-worldsview-orange">Lost</p>
                  <p className="text-sm text-muted-foreground">The opportunity was lost to a competitor or other factors</p>
                </div>
              </div>
            </Button>

            <Button
              onClick={onCancelled}
              variant="outline"
              className="w-full justify-start h-auto py-4 border-worldsview-red hover:bg-worldsview-red/10"
            >
              <div className="flex items-start gap-3">
                <Ban className="w-5 h-5 text-worldsview-red mt-0.5" />
                <div className="text-left min-w-0">
                  <p className="font-medium text-worldsview-red">Cancelled</p>
                  <p className="text-sm text-muted-foreground">The opportunity was cancelled or is no longer valid</p>
                </div>
              </div>
            </Button>
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4 border-t">
          <Button
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
